import React, { useEffect, useState, useRef } from "react";
import Header from '../../components/header/Header';
import Sidebar from '../../components/sidebar/Sidebar';
import { useNavigate } from "react-router-dom";
import { addNotifications, customersListing } from "../../api/apiHandler";
import { showMessage, showErrorMessage } from "../common/Utils";
import $ from 'jquery';
import Select from 'react-select';
import "parsleyjs/src/parsley.css";
import "parsleyjs";

export function AddNotification() {

    let addFormRef = useRef(null);
    let navigate = useNavigate();
    const auth = localStorage.getItem('token');

    if (!auth) {
        navigate('/login');
    }

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [content, setContent] = useState("");
    const [customers, setCustomers] = useState([]);
    const [selectedCustomers, setSelectedCustomers] = useState([]);

    const fetchInitialCustomers = async () => {
        try {
            const response = await customersListing({ search: "", page: 1 });
            if (parseInt(response.code) === 1) {
                const customersData = response.data.items.map((cust) => ({
                    value: cust.id,
                    label: `${cust.first_name} ${cust.last_name}`
                }));

                setCustomers([{ value: "all", label: "All Customers" }, ...customersData]);
            }
        } catch (error) {
            console.error("Error loading customers:", error);
        }
    };

    useEffect(() => {
        fetchInitialCustomers();
        // window.Parsley && window.Parsley.addValidator("custom", {
        //     validateString: () => true
        // });
        $(addFormRef.current).parsley();
    }, []);

    const handleAddRequest = async (e) => {
        e.preventDefault();

        if (isSubmitting) return; // safety net

        setIsSubmitting(true);
        
        if ($(addFormRef.current).parsley().isValid()) {
            const customerIds = selectedCustomers.map(c => c.value);

            console.log("customerIds : ", customerIds);
            const saveNotify = {
                content: content,
                customer_ids: customerIds,
                content_type: 'Notification'
            };

            const response = await addNotifications(saveNotify);
            if (parseInt(response.code) === 1) {
                showMessage(response.message);
                navigate('/notifications/listing');
            } else {
                showErrorMessage(response.message);
            }
        } else {
            showErrorMessage("Something went wrong, some required fields are missing!");
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <>
            <Header />
            <Sidebar />
            <section className="content">
                <div className="block-header">
                    <div className="row">
                        <div className="col-lg-7 col-md-6 col-sm-12">
                            <h2>Add Notification</h2>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12">
                            <ul className="breadcrumb float-md-right">
                                <li className="breadcrumb-item">
                                    <a href="/authpanel/dashboard">
                                        <i className="zmdi zmdi-home" /> Dashboard
                                    </a>
                                </li>
                                <li className="breadcrumb-item">
                                    <a href="/authpanel/notifications/listing">
                                        Notifications
                                    </a>
                                </li>
                                <li className="breadcrumb-item active">Add Notification</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <div className="card">
                                <div className="body">
                                    <div className="col-md-10 col-lg-10 col-xl-10 offset-md-1">
                                        <form name="add_notification" id="add_notification" ref={addFormRef} onSubmit={handleAddRequest}>
                                            <div className="row">
                                                <div className="col-md-8 col-lg-8 col-xl-8 offset-md-2">
                                                    <div className="form-group form-float">
                                                        <div className="form-line focused">
                                                            <textarea
                                                                style={{ height: '100px' }}
                                                                className="form-control"
                                                                name="content"
                                                                id="content"
                                                                data-parsley-trigger="change"
                                                                data-parsley-required-message="Please enter content"
                                                                data-parsley-required="true"
                                                                maxLength={150}
                                                                value={content}
                                                                onChange={(e) => setContent(e.target.value)}
                                                            />
                                                            <small className="form-text text-right d-block" style={{ color: '#FF0000' }}>
                                                                {content.length}/150 characters used
                                                            </small>
                                                            <label className="form-label">
                                                                Content <span className="text-danger">*</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="clearfix" />

                                                <div className="col-md-8 col-lg-8 col-xl-8 offset-md-2">
                                                    <div className="form-group">
                                                        <label className="mb-3">Choose Users</label>
                                                        <Select
                                                            isMulti
                                                            name="customer_ids"
                                                            options={customers}
                                                            value={selectedCustomers}
                                                            onChange={(selected) => {
                                                                if (selected.some(opt => opt.value === "all")) {
                                                                    // If "All Customers" is selected, only show "All Customers"
                                                                    setSelectedCustomers([{ value: "all", label: "All Customers" }]);
                                                                } else {
                                                                    // Otherwise, update selected customers normally
                                                                    setSelectedCustomers(selected);
                                                                }
                                                            }}
                                                            placeholder="Select Customers"
                                                            classNamePrefix="react-select"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="clearfix" />
                                                <div className="col-md-8 col-lg-8 col-xl-8 offset-md-2 text-center">
                                                    <div className="form-group">
                                                        <button type="submit" className="btn btn-raised btn-primary waves-effect m-t-20 mr-3" disabled={isSubmitting} style={ { color: '#FFFFFF' } }>
                                                            {isSubmitting ? 'Sending..' : 'Submit'}
                                                        </button>
                                                        <a
                                                            href="#"
                                                            onClick={handleGoBack}
                                                            className="btn btn-raised btn-default waves-effect m-t-20"
                                                        >
                                                            Cancel
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}